import { Helmet } from "react-helmet-async";
import { Button, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { connect } from "react-redux";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import FilterBar from "../../components/FilterBar/FilterBar";
import { useEffect, useRef, useState } from "react";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import {
  changePageSizeSnippet,
  cleanMessageSnippet,
  getListaSnippet,
  getSnippetHistoryList,
  getSnippetPreview, 
  getSnippetProducts,
  getSnippetSections, 
  loadEmptySnippet,
  postSnippetDownloadList,
} from "../../store/snippets/actions";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import { Pill } from "../../components/Pill/Pill";
import { useNavigate } from "react-router-dom";
import PillModal from "../../components/PillModal/PillModal";
import { openHtmlAsPdfPreview } from "../../helpers/utils/openHtmlAsPdfPreview";
import useAlert from "../../customHooks/useAlert";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import ActionList from "../../components/ActionList/ActionList";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import downloadBase64File from "../../helpers/downloadBase64File";
const SnippetsList = ({
  getListSnippetRequest,
  getSnippetHistoryList,
  getSnippetProducts,
  getSnippetSections,
  getSnippetPreviewRequest,
  listaSnippet,
  listaSnippetHistory,
  loadingSnippet,
  loadEmptySnippet,
  loadingSnippetHistory,
  messageSnippet,
  cleanMessageSnippet,
  errorLoadingSnippetHistory,

  loadingProducts,
  errorProducts,
  snippetProducts,

  snippetSections,
  loadingSections,
  errorSections,

  snippetPreview,
  errorSnippetPreview,

  pageSizeSnippet,
  changePageSizeSnippet,

  postSnippetDownloadList,
  snippetsList,
  errorSnippetsList,
}) => {
  const [objFilter, setObjFilter] = useState({
    status: true,
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    products: [],
    sections: [],
    createUsers: [],
    updateUsers: [],
    searchText: null,
  });
  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeSnippet,
    page: 0,
  });

  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentSnippetHistory, setIdCurrentSnippetHistory] = useState(null);
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaSnippetHistory?.totalRecords || 0) / pageSizeHistory
  );
  const handlePageChangeHistory = (page) => {
    if (!idCurrentSnippetHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);

    getSnippetHistoryList({
      snippetId: idCurrentSnippetHistory,
      page,
    });
  };

  const { errorAlert, successAlert } = useAlert();

  const isFirstRender = useIsFirstRender();
  const navigate = useNavigate();
  const titlePreviewRef =  useRef("");

  const handlePageChange = (model) => {
    const { page, pageSize } = model;

    setPaginationModel({ pageSize: pageSize, page: page });
    changePageSizeSnippet(pageSize);

    getListSnippetRequest({
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      products: objFilter.products,
      sections: objFilter.sections,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      searchText: objFilter.searchText,
      status: objFilter.status,
    });
  };
  const handleSortChange = (model) => {
    console.log(model);
    setTimeout(() => {
      //
    }, 300);
  };
  const handleRowClick = (params, event) => {
    navigate(`/snippet?id=${params.id}`);
  };
  const fetchSnippetHistory = (snippetId) => {
    getSnippetHistoryList({ snippetId, page: 1 });
  };
  const handleDetailSnippetHistory = (item) => {
    window.open(`/snippet?idHistory=${item.idHistory}`, "_blank");
  };
  const fetchQuantityProducts = (snippetId) => {
    getSnippetProducts({ snippetId });
  };
  const fetchQuantitySections = (snippetId) => {
    getSnippetSections({ snippetId });
  }
  const handleSnippetPreview = (e, snippetId, title) => {
    e.stopPropagation();
    titlePreviewRef.current = title;
    getSnippetPreviewRequest({ snippetId });
  }
  const handleDownladSnippetsList = () => {
    const normalizedFilter = {
      ...objFilter,
      createDateStart: objFilter.createDateStart || null,
      createDateEnd: objFilter.createDateEnd || null,
      updateDateStart: objFilter.updateDateStart || null,
      updateDateEnd: objFilter.updateDateEnd || null,
    }

    postSnippetDownloadList({ objFilter: normalizedFilter });
  }

  const actions = useContextActions({
    context: "snippet",
    screen: "list",
  })
 
  const columns = [
    {
      field: "createDate",
      headerName: "Creation date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "title",
      headerName: "Snippet Title",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "description",
      headerName: "Snippet Description",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "totalProducts",
      headerName: "Products",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalProducts}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M272 32L368 32C385.7 32 400 46.3 400 64C400 81.7 385.7 96 368 96L272 96C254.3 96 240 81.7 240 64C240 46.3 254.3 32 272 32zM176 208C176 172.7 204.7 144 240 144L400 144C435.3 144 464 172.7 464 208C464 232.1 450.7 253.1 431 264C450.7 274.9 464 295.9 464 320C464 344.1 450.7 365.1 431 376C450.7 386.9 464 407.9 464 432C464 456.1 450.7 477.1 431 488C450.7 498.9 464 519.9 464 544C464 579.3 435.3 608 400 608L240 608C204.7 608 176 579.3 176 544C176 519.9 189.3 498.9 209 488C189.3 477.1 176 456.1 176 432C176 407.9 189.3 386.9 209 376C189.3 365.1 176 344.1 176 320C176 295.9 189.3 274.9 209 264C189.3 253.1 176 232.1 176 208z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantityProducts(params.row.id);
          }}
          loading={loadingProducts}
          data={snippetProducts}
          error={errorProducts}
          view="snippet" //View que estamos singular
          variant="Products" //Variante no plural
        />
      ),
    },
    {
      field: "totalSections",
      headerName: "Sections",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSections}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M465.4 192L431.1 144L209 144L174.7 192L465.4 192zM96 212.5C96 199.2 100.2 186.2 107.9 175.3L156.9 106.8C168.9 90 188.3 80 208.9 80L431 80C451.7 80 471.1 90 483.1 106.8L532 175.3C539.8 186.2 543.9 199.2 543.9 212.5L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 212.5z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySections(params.row.id);
          }}
          loading={loadingSections}
          data={snippetSections}
          error={errorSections}
          view="snippet" //View que estamos singular
          variant="Sections" //Variante no plural
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <ActionList id={params.row.id} title={params.row.title} onPreview={handleSnippetPreview} actions={actions}/>
      ),
    },
    {
      field: "id",
      headerName: "History",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params, index) => (
        <HistoryModal
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchSnippetHistory(params.value);
            setCurrentPageHistory(1);
            setIdCurrentSnippetHistory(params.value);
          }}
          loading={loadingSnippetHistory}
          data={listaSnippetHistory?.records}
          onDetail={handleDetailSnippetHistory}
          errorLoadingHistory={errorLoadingSnippetHistory}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}

          columns={[
            {
              key: "updateDate",
              render: (item) =>
                moment(
                  item.updateDate === null ? item.createDate : item.updateDate,
                ).format("DD MMM/YY hh:mm A"),
            },
            { key: "title" },
            {
              key: "updateUser",
              render: (item) =>
                item.updateUser === null ? item.createUser : item.updateUser,
            },
          ]}
        />
      ),
    },
  ];

  useEffect(() => {
    if (messageSnippet) {
      errorAlert(
        messageSnippet !== null ? messageSnippet : "Something wrong, try again later.",
        {
          timer: undefined,
          timerProgressBar: false,
          didClose: () => cleanMessageSnippet(),
        }
      )
    }
    // eslint-disable-next-line
  }, [messageSnippet]);
  useEffect(() => {
    setPaginationModel((prev) => ({
      ...prev,
      page: 0,
    }));
    getListSnippetRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      products: objFilter.products,

      sections: objFilter.sections,

      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,

      searchText: objFilter.searchText,
      status: objFilter.status,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objFilter]);

  useEffect(() => {
      if (snippetPreview) {
        openHtmlAsPdfPreview({
          html: snippetPreview.html,
          title: titlePreviewRef.current || "Snippet Preview",
        });
      }
  
      return () => {
        loadEmptySnippet();
      }
      // eslint-disable-next-line
  }, [snippetPreview]);
  useEffect(() => {
    if (errorSnippetPreview) {
      errorAlert(
        errorSnippetPreview !== null ? errorSnippetPreview : "Something wrong, try again later.",
        {
          timer: undefined,
          timerProgressBar: false,
          didClose: () => loadEmptySnippet(),
        }
      );
    }
    // eslint-disable-next-line
  }, [errorSnippetPreview]);
  useEffect(() => {
      async function handleDownload() {
        if (snippetsList) {
          const base64 = snippetsList;
          const fileName = `Snippets_${moment().format("YYYYMMDD")}.xlsx`;
  
          const success = await downloadBase64File(base64, fileName, "xlsx");
  
          if (success) {
            successAlert("Snippets list downloaded successfully", {
              didClose: () => {
                cleanMessageSnippet();
              },
            });
          }
  
          return;
        }
  
        if (errorSnippetsList) {
          errorAlert(errorSnippetsList || "Try again later!", {
            didClose: () => {
              cleanMessageSnippet();
            },
          });
        }
      }
  
      handleDownload();
  
      return () => {
        cleanMessageSnippet();
      }
    // eslint-disable-next-line
  }, [snippetsList, errorSnippetsList]);
  
  return (
    <div className="page-content">
      <Helmet>
        <title>Snippets</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div>
                  <Row>
                    <div className="d-flex justify-content-between my-2">
                      <h2>SNIPPETS</h2>
                      <div className="d-flex gap-2 mb-4">
                        <ActionButtons 
                          actions={actions}
                          context="snippet"
                          handlers={{
                            create: () => navigate("/snippet")
                          }}
                        />
                      </div>
                    </div>
                    <Row>
                      <Col md={12}>
                        <FilterBar
                          setObjFilter={setObjFilter}
                          placeholderSearch="Search by snippet title or description"
                          isFirstRender={isFirstRender}
                          variant="snippets"
                        />
                      </Col>
                    </Row>

                    <Row className="my-2">
                      {loadingSnippet ? (
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: "400px", width: "100%" }}
                        >
                          <Spinner
                            color="primary"
                            style={{ height: "5rem", width: "5rem" }}
                          />
                        </div>
                      ) : (
                        <>
                          <div className="d-flex align-center justify-content-end gap-2 mb-3">
                            <ButtonCustom 
                              type="export"
                              onClick={handleDownladSnippetsList}
                              disabled={listaSnippet.records.length === 0}
                            />
                          </div>
                          <CustomDatatable
                            columns={columns}
                            rows={listaSnippet.records}
                            pagination
                            paginationMode="server"
                            rowCount={listaSnippet?.totalRecords ?? 0}
                            paginationModel={paginationModel}
                            onPaginationModelChange={handlePageChange}
                            onSortModelChange={handleSortChange}
                            onRowClick={handleRowClick}
                            pageSizeOptions={PAGE_SIZE_OPTIONS}
                            checkboxSelection={false}
                            disableColumnFilter
                            disableColumnMenu
                        />
                        </>
                      )}
                    </Row>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  SnippetsReducer: {
    listaSnippet,
    listaSnippetHistory,
    loadingSnippet,
    loadingSnippetHistory,
    messageSnippet,
    errorLoadingSnippetHistory,
    loadingProducts,
    errorProducts,
    snippetProducts,
    snippetSections,
    loadingSections,
    errorSections, 
    snippetPreview, 
    errorSnippetPreview ,
    pageSizeSnippet,
    snippetsList,
    errorSnippetsList,
  },
}) => ({
  listaSnippet,
  listaSnippetHistory,
  loadingSnippet,
  loadingSnippetHistory,
  messageSnippet,
  errorLoadingSnippetHistory,

  loadingProducts,
  errorProducts,
  snippetProducts,

  snippetSections,
  loadingSections,
  errorSections,

  snippetPreview,
  errorSnippetPreview,

  pageSizeSnippet,

  snippetsList,
  errorSnippetsList,
});

const mapDispatchToProps = {
  getListSnippetRequest: getListaSnippet.request,
  getSnippetHistoryList: getSnippetHistoryList.request,
  getSnippetProducts: getSnippetProducts.request,
  getSnippetSections: getSnippetSections.request,
  getSnippetPreviewRequest: getSnippetPreview.request,
  postSnippetDownloadList: postSnippetDownloadList.request,
  cleanMessageSnippet,
  loadEmptySnippet,
  changePageSizeSnippet,
};

export default connect(mapStateToProps, mapDispatchToProps)(SnippetsList);
